import React from 'react';
import Styles from './logo.module.scss';

const Logo = () => <img className={Styles.logo} src="https://uiux-assets.sendgrid.com/logo/sg-twilio-lockup.svg" alt="SendGrid Logo" data-role="logo" />;

export default Logo;
